const returnPolicyDays = document.body.querySelector<HTMLUListElement>("nav.main-nav > ul")?.dataset.returnPolicyDays;

export const getReturnPolicyDays = () => returnPolicyDays;
